import React from "react";
import Icon from "@awsui/components-react/icon";

const SecondPositionIcon: React.FC = () => {
    return (
        <Icon
            url="https://img.icons8.com/color/96/olympic-medal-silver.png"
        />
    );
};

export default SecondPositionIcon;
